import React from 'react';
import Box from '@material-ui/core/Box';
import FormControl from '@material-ui/core/FormControl';
import Popover, {PopoverOrigin} from '@material-ui/core/Popover';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Picker from 'react-daterange-picker';
import moment from 'moment';
import {DateRange} from 'moment-range';

import Arrows from './DateRangeArrows';
import {DateRangePreselects} from './DateRangeTypes';
import {FORMAT} from './index';

import 'react-daterange-picker/dist/css/react-calendar.css';
import './DateRangePicker.scss';

export default function DateRangePicker(props: any) {
    const {
        handlePlaceholderClick,
        valueFull,
        open,
        anchorEl,
        handleClose,
        onPickerSelect,
        dates,
        preselect,
        onPreselectChange,
        startDate,
        onStartDateChange,
        onStartDateBlur,
        endDate,
        onEndDateChange,
        onEndDateBlur,
        placeholder,
        onClear,
    } = props;
    const anchorOrigin: PopoverOrigin = {
        vertical: 'bottom',
        horizontal: 'center',
    };
    const transformOrigin: PopoverOrigin = {
        vertical: 'top',
        horizontal: 'center',
    };
    const initialYear = moment().startOf('day').year();
    const initialMonth = moment().startOf('day').month();
    
    return (
        <Box className="daterange">
            <TextField
                className="daterange__preselects-placeholders-value"
                aria-describedby="daterange-popover"
                onClick={handlePlaceholderClick}
                type="text"
                label={placeholder}
                value={valueFull}
            />
            <Popover
                className="daterange-popover"
                id="daterange-popover"
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={anchorOrigin}
                transformOrigin={transformOrigin}
            >
                <Picker
                    onSelect={onPickerSelect}
                    value={dates as DateRange}
                    firstOfWeek={1}
                    paginationArrowComponent={Arrows}
                    initialYear={initialYear}
                    initialMonth={initialMonth}
                    singleDateRange
                />
                <Box className="daterange__preselects">
                    <FormControl className="daterange__preselects-options">
                        <InputLabel id="daterange__preselects-opts">Date range</InputLabel>
                        <Select
                            labelId="daterange__preselects-opts"
                            value={preselect}
                            onChange={onPreselectChange}
                        >
                            <MenuItem
                                value={DateRangePreselects.CUSTOM}
                            >
                                Custom
                            </MenuItem>
                            <MenuItem
                                value={DateRangePreselects.Today}
                            >
                                Today
                            </MenuItem>
                            <MenuItem
                                value={DateRangePreselects.Tomorrow}
                            >
                                Tomorrow
                            </MenuItem>
                            <MenuItem
                                value={DateRangePreselects.LastTwoWeeks}
                            >
                                Last 2 weeks
                            </MenuItem>
                            <MenuItem
                                value={DateRangePreselects.NextTwoWeeks}
                            >
                                Next 2 weeks
                            </MenuItem>
                        </Select>
                    </FormControl>
                    <Box className="daterange__preselects-placeholders">
                        <TextField
                            className="daterange__preselects-placeholders-value"
                            type="text"
                            placeholder={FORMAT}
                            value={startDate}
                            onChange={onStartDateChange}
                            onBlur={onStartDateBlur}
                        />
                        
                        <TextField
                            className="daterange__preselects-placeholders-value"
                            type="text"
                            placeholder={FORMAT}
                            value={endDate}
                            onChange={onEndDateChange}
                            onBlur={onEndDateBlur}
                        />
                    </Box>
                    <span
                        role="button"
                        className="daterange__preselects-clear"
                        onClick={onClear}
                    >
                        Clear filter
                    </span>
                </Box>
            </Popover>
        </Box>
    );
}
